<template>
  <div>
    <div class="app" v-cloak>
      <!--      <transition :name="transitionName">-->
      <keep-alive :include="include" :max="2">
        <router-view class="router" ref="router" v-if="isRouterAlive"></router-view>
      </keep-alive>
      <!--      </transition>-->
    </div>
    <Footer v-if="footer === true"></Footer>
    <div class="homeBack" @click="routerBack()" v-else><span data-v-d8a79f8c="" class="iconfont icon-jiantou"></span>
    </div>
    <a :href="weChatServiceInfo">
      <div class="home-service" :style="{ top: top + 'px' }" @touchmove.stop.prevent="setTouchMove"
        v-if="Boolean(weChatServiceInfo)">
        <img src="./assets/images/kefu.png" alt="">
      </div>
    </a>
    <!-- <Home v-if="home === true"></Home> -->
  </div>
</template>
<script>
function isKeepAlive($route) {
  console.log('$route', $route);
  return $route.meta.keepAlive === undefined || $route.meta.keepAlive;
}

import { getUser } from "@api/user";
import { getWechatService } from '@api/store'
import Footer from "@components/Footer";
// import Home from "@components/Home";
import { mapGetters } from "vuex";
import { openShareAll } from "@libs/wechat";
import { getShare, routinemain } from "@api/public";
import { isWeixin } from "@utils/index";

export default {
  data() {
    return {
      isRouterAlive: true, //   是否刷新页面
      transitionName: "fold-right",
      // include: isKeepAlive(this.$route) ? [this.$route.name] : [],
      include: ['Index','GoodsFittingList','smallshop','GoodsPromotion','registerGoods'], //缓存首页和可滑动的列表页
      history: [],
      top: 150,
      weChatServiceInfo: ''
    };
  },
  provide() {
    return {
      app: this,
      reload: this.reload,
    };
  },
  computed: mapGetters(["footer", "home", "isLogin"]),
  components: {
    Footer
    // Home
  },
  watch: {
    $route(to, from) {
      const lastPath = this.history[this.history.length - 1] || {},
        { isReplace, isBack } = this.$router;

      if (lastPath.path === to.path) {
        this.transitionName = "fold-right";
        this.history.pop();
      } else {
        this.transitionName = "fold-left";
        if (!isReplace) this.history.push({ path: from.path, name: from.name });
      }

      // if (isKeepAlive(to) && to.name !== "Login") {
      //   !this.include.includes(to.name) && this.include.push(to.name);
      // }

      // if (isKeepAlive(from) && isBack) {
      //   var index = this.include.indexOf(from.name);
      //   index !== -1 && this.include.splice(index, 1);
      // }

      this.$router.isBack = false;
      this.$router.isReplace = false;

      console.log(this.transitionName, "change");
    }
  },
  mounted: function () {
    routinemain().then(res => {
      if (res.msg == 1) {
        this.$router.replace({
          path: "/maintain"
        })
      }
    })
    this.setOpenShare();
    this.User();
  },
  methods: {
    // 刷新页面数据
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    User: function () {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        that.orderStatusNum = res.data.orderStatusNum;
        this.generalContent = {
          promoterNum: `您在商城累计消费金额仅差 <span style="color: #80cdd4;">${res
            .data.promoter_price || 0}元</span>即可开通推广权限`,
          title: "您未获得推广权限"
        };
      });
      getWechatService().then(res => {
        this.weChatServiceInfo = res.data[0].url ? res.data[0].url : ''
      }).catch(err => {
        console.log('err----------------------------------->', err);
      })
    },
    setOpenShare: function () {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    },
    routerBack: function () {
      // this.$router.go(-1)   
      if (window.history.length > 1) {
          this.$router.go(-1);  // 存在历史记录则返回
        } else {
          this.$router.replace('/');  // 无历史记录则替换到首页
        }

    },
    // 客服按钮移动
    setTouchMove: function (e) {
      if (e.touches[0].clientY < 450 && e.touches[0].clientY > 100) {
        this.top = e.touches[0].clientY
      }
    }
  }
};
</script>
<style lang="scss">
.home-service {
  width: 1.3rem;
  height: 1.3rem;
  right: 0;
  position: fixed;
  z-index: 9999;
}

.home-service>img {
  width: 100%;
}

[v-cloak] {
  display: none !important;
}

.router {
  position: absolute;
  width: 100%;
}

.fold-left-enter-active {
  animation-name: fold-left-in;
  animation-duration: 0.5s;
}

.fold-left-leave-active {
  animation-name: fold-left-out;
  animation-duration: 0.5s;
}

@keyframes fold-left-in {
  0% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  10% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fold-left-out {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

.fold-right-enter-active {
  animation-name: fold-right-in;
  animation-duration: 0.5s;
}

.fold-right-leave-active {
  animation-name: fold-right-out;
  animation-duration: 0.5s;
}

@keyframes fold-right-in {
  0% {
    width: 100%;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  10% {
    width: 100%;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  100% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fold-right-out {
  0% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  100% {
    width: 100%;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}
</style>
